/*global angular */
'use strict';

angular.module('MrDWebApp')
    .controller('SEOCtrl', function ($scope, $rootScope, $stateParams, $filter, SEO) {

        var _seo = this;
        
        _seo.isCity = true;
        _seo.term_type_secondary = false;
        _seo.term_slug_secondary = false;
        
        if($stateParams.group){

            _seo.term_slug = $stateParams.group;
            _seo.term_name = $filter('filter')($scope._rc.groups,{ 'slug' : $stateParams.group })[0].name;
            _seo.term_cover = $filter('filter')($scope._rc.groups,{ 'slug' : $stateParams.group })[0].cover;
            _seo.term_logo = $filter('filter')($scope._rc.groups,{ 'slug' : $stateParams.group })[0].logo;            
            _seo.term_count = $filter('filter')($scope._rc.groups,{ 'slug' : $stateParams.group })[0].count;
            _seo.term_tags = $filter('filter')($scope._rc.groups,{ 'slug' : $stateParams.group })[0].tags;
            _seo.term_tags_array = $filter('filter')($scope._rc.groups,{ 'slug' : $stateParams.group })[0].tags_array;
            
            _seo.term_tags_array.unshift('take-aways');
            _seo.term_tags_array.unshift('food');
            _seo.term_tags_array.unshift('delivery');


            $rootScope.$broadcast('seo_update', { overwrite: { 
                title_tag: _seo.term_name + ' Delivery | Order online | Mr D Food',
                description_tag: 'Get delivery from from over '+_seo.term_count+' '+_seo.term_name+' restaurants in South Africa! FREE delivery on your first app order',
                keywords_tag: _seo.term_tags_array.join(',')
            } });
            

        } else {

            _seo.term_type = $rootScope.seo_manifest[$stateParams.first];
            _seo.term_slug = $stateParams.first;
            _seo.term_has_suburbs = true;

            if($stateParams.second) {
                _seo.term_type = $rootScope.seo_manifest[$stateParams.second];
                _seo.term_slug = $stateParams.second;

                _seo.term_type_secondary = $rootScope.seo_manifest[$stateParams.first];

                if(_seo.term_type === 'suburb'){
                    _seo.term_slug_secondary = $stateParams.first;
                    _seo.term_name_secondary = $filter('filter')($scope._rc.cities,{ 'slug' : $stateParams.first })[0].name;
                }
                _seo.isCity = false;
            }  

            if(_seo.term_type === 'cuisine_type'){
                _seo.term_name = $filter('filter')($scope._rc.cuisine_types,{ 'slug' : $stateParams.first })[0].name;
                $rootScope.$broadcast('seo_update', { overwrite: { 
                    title_tag: _seo.term_name + ' | Order online | Mr D Food',
                    description_tag: 'Get '+_seo.term_name+' delivered fast and hot from restaurants across South Africa! FREE delivery on your first app order',
                    keywords_tag: SEO.keywordsTag('default')
                } });
            }
            if(_seo.term_type === 'city'){
                _seo.term_name = $filter('filter')($scope._rc.cities,{ 'slug' : $stateParams.first })[0].name;
                _seo.term_has_suburbs = $filter('filter')($scope._rc.cities,{ 'slug' : $stateParams.first })[0].suburbs;
                $rootScope.$broadcast('seo_update', { overwrite: { 
                    title_tag: _seo.term_name + ' Food Delivery | Order online | Mr D Food',
                    description_tag: 'Get food delivered fast and hot from restaurants across '+_seo.term_name +'! FREE delivery on your first app order',
                    keywords_tag: SEO.keywordsTag('default')
                } });
            }
            if(_seo.term_type === 'suburb'){
                _seo.term_name = $filter('filter')($scope._rc.hubs_master,{ 'slug' : $stateParams.second })[0].name; // Used Second
                _seo.term_has_suburbs = false; // Used Second
                $rootScope.$broadcast('seo_update', { overwrite: { 
                    title_tag: _seo.term_name + ' Delivery | Order online | Mr D Food',
                    description_tag: 'Get delivery from restaurants in '+_seo.term_name +'! FREE delivery on your first app order',
                    keywords_tag: SEO.keywordsTag('default')
                } });
            }
        }            

        _seo.headerClass = function(){
            if(_seo.term_slug_secondary) {
                return 'seo-header-' + _seo.term_slug_secondary;  
            }
            return 'seo-header-' + _seo.term_slug;
        };


    });